import "./App.css";
import React from "react";
import SearchModule from "./SearchModule";


function App()
{
  return (
    <div className="App">
      <header className="App-header">
        <div>
          <SearchModule/>
          
        </div>
      </header>
    </div>
  );
}

export default App;
